export const SESSION_INACTIVITY_TIMEOUT_MS = 30 * 60 * 1000;
export const SESSION_INACTIVITY_CHECK_INTERVAL_MS = 30 * 1000;
export const SESSION_ACTIVITY_WRITE_THROTTLE_MS = 5 * 1000;
export const SESSION_ACTIVITY_PING_AFTER_MS = 10 * 60 * 1000;
export const SESSION_ACTIVITY_PING_RETRY_MS = 60 * 1000;
export const SESSION_ACTIVITY_PING_PATH = "/v1/account-settings";
export const SESSION_INACTIVITY_DETAIL = "Session expired due to inactivity";
export const SESSION_EXPIRED_REASON_PARAM = "reason";
export const SESSION_EXPIRED_INACTIVITY_REASON = "inactivity";
export const SESSION_LAST_ACTIVITY_STORAGE_KEY = "session.lastActivityAt";
export const SESSION_LAST_API_REQUEST_STORAGE_KEY = "session.lastApiRequestAt";
